import { dueAfterDays } from './dayBoundary';

// ─────────────────────────────────────────────────────────────────────────────
// Flashcard scheduling: the app's SM-2 (app/srs.ts), with two buttons.
//
// Gibberfish grades on four buttons (Again / Hard / Good / Easy). Students here
// get two, because four is a decision a beginner should not have to make on
// every card:
//
//   Forgot  = Again (quality 1)  back to a 1-day interval, review count reset
//   Good    = Good  (quality 4)  the textbook ladder: 1 day, 6 days, then × ease
//
// Ease only moves on Good (it stays put at quality 4 — SM-2's +0.1 − 0.1), so
// with two buttons a card's ease never drifts; the ladder is driven by the
// review count, as vocabulary is in the app.
// ─────────────────────────────────────────────────────────────────────────────

export type SrsState = { interval: number; easeFactor: number; reviewCount: number };
export type Grade = 'good' | 'forgot';

export function schedule(item: SrsState, grade: Grade, now: Date = new Date()) {
  let { interval, easeFactor, reviewCount } = item;
  const quality = grade === 'good' ? 4 : 1;

  if (quality < 3) {
    interval = 1;
    reviewCount = 0;
  } else {
    interval = reviewCount === 0 ? 1 : reviewCount === 1 ? 6 : Math.round(interval * easeFactor);
    easeFactor = Math.max(1.3, easeFactor + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02)));
    reviewCount += 1;
  }

  return { interval, easeFactor, reviewCount, nextReview: dueAfterDays(interval, now) };
}

/** "in 6 days", for the button hint. */
export function whenLabel(days: number): string {
  if (days <= 1) return 'tomorrow';
  if (days < 30) return `in ${days} days`;
  const months = Math.round(days / 30);
  return months <= 1 ? 'in a month' : `in ${months} months`;
}
